<template>

</template>

<script>
import axios from "axios";
export default {
  name: "SetDefaultCurrency",
  emits: ['change-currency'],
  setup(props, ctx) {
    const setCurrency = (code = null) => {
      const data = {
        code: code
      }
      axios.post('/api/currency/set?' + 'rand=' + Math.random(), data).then((response) => {
        if(response.data.success) {
          console.log("Currency set to " + response.data.code);
          localStorage.setItem('currency', response.data.code);
          ctx.emit('change-currency', response.data.code);
          const event = new CustomEvent('update-results', { detail: { currency: response.data.code } });
          window.dispatchEvent(event);
        }
      });
    }
    let params = new URLSearchParams(window.location.search);
    if(localStorage.getItem('currency') && !params.has('currency')) {
      console.log(0)
      setCurrency(localStorage.getItem('currency'));
    } else if(params.has('currency')) {
      setCurrency(params.get('currency'));
    } else {
      setCurrency(null);
    }
  }
}
</script>

<style scoped>

</style>
